const user = {
  idUser: "dkdlel@naver.com",
  pwUser: "1234",
};

export default user;
